import { useParameterMaintenanceVM } from "presentation/hook/Parameter/useParameterMaintenanceVM";
import { useParameterMaintenanceTracked } from "presentation/store/Parameter/ParameterMaintenanceProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { ParameterCodeEditPanel } from "./Form/ParameterCodeEditPanel";
import ParameterTablePanel from "./Table/ParameterTablePanel";

const ParameterMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [paramMainState] = useParameterMaintenanceTracked();
    const paramMainVM = useParameterMaintenanceVM();
    const { isBackMaster, isShowEditPanel } = paramMainState;


    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                const results = await Promise.allSettled([
                    paramMainVM.loadDropdownOption(),
                    paramMainVM.searchParameter()
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then(async () => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [isBackMaster, paramMainVM])



    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowEditPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowEditPanel ? "70%" : "100%"}
                rightSectionWidth={isShowEditPanel ? "30%" : "0%"}
                leftChildren={<ParameterTablePanel />}
                rightChildren={<ParameterCodeEditPanel />}
            />
        </div>
    </>
}

export default memo(ParameterMaintenance);